import React, { useEffect, useState, useContext } from 'react';

import { useHistory } from "react-router-dom";
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import 'suneditor/dist/css/suneditor.min.css';

import NewsContext from '../../context/news-context';
import { getNewsById } from '../../actions/news-actions'
import NewsDetailHolder from './NewsDetailHolder'
import { BreadcrumbsCustom } from '../shared/component'

import useStyles from "../../styles/components/notification/stylesNotification";
import useStylesNews from "../../styles/components/news/stylesNewsDetail";
import { getIconNews } from '../../utils/helpers/icon/iconHelper'
import { News } from '../../utils/services/cache/ClientCache'

const NewsDetail = () => {
    const classes = useStyles();
    const styles = useStylesNews();
    const history = useHistory();
    const { newsContext, dispatch } = useContext(NewsContext);
    const [news, setNews] = useState(null);
    const [showScroll, setShowScroll] = useState(false)
    const id = News.getNewsId()

    useEffect(() => {

        const initNewsById = async () => {
            const response = await getNewsById(id);
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            dispatch({ type: 'SET_NEWS_DETAIL', newsDetail: response.data })
            setNews(response.data)

        }

        initNewsById();
        window.addEventListener('scroll', checkScrollTop)

        return () => window.removeEventListener('scroll', checkScrollTop)
    }, [])

    const breadcrumb = () => history.goBack()

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400) {
            setShowScroll(true)
        } else if (showScroll && window.pageYOffset <= 400) {
            setShowScroll(false)
        }
    };

    const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

    const breadcrumbsData = [
        {
            type: 'Survey',
            text: 'News',
            href: '/News'
        },
        {
            type: 'Survey',
            text: news && news.title,
            href: ''
        },
    ];



    return (
        <>
            <Grid container justify="center" direction="column" alignItems="center" classes={{ root: styles.rootGrid }}>
                <Grid item xs={12} sm={12} md={9} lg={6}>
                    <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                    <br />
                    {news && newsContext && Object.keys(newsContext.newsDetail).length !== 0 &&
                        <NewsDetailHolder />
                    }
                    <div className={classes.rootGridButton}>
                        <Chip
                            onClick={scrollTop}
                            style={{ height: 40, display: showScroll ? "flex" : "none" }}
                            label={<img src={getIconNews().arrowBack} />}
                            className={clsx(classes.btnOnTop, classes.btnCommon)}
                        />
                        <Chip
                            label={<img src={getIconNews().arrowBackUp} />}
                            onClick={() => breadcrumb()}
                            className={clsx(classes.btnComeBack, classes.btnCommon)}
                        />
                    </div>
                </Grid>
            </Grid>
        </>
    );
};

export { NewsDetail as default }